import { Box } from "@mui/material"

export function CreateUniqueValue() {
    return (
        <Box py={0.5} px={1}>
            No unique fields
        </Box>
    )
}
